const watermarkCache = {};
const genWatermark = (options) => {
    const stringifyOpts = JSON.stringify(options);
    if (watermarkCache[stringifyOpts]) {
        return watermarkCache[stringifyOpts];
    }
    const { watermarkText = '', rotatAngle = -30, textColor = 'rgba(220, 220, 220, 0.5)', font = '12px sans-serif', } = options;
    const base = 80;
    const SQRT_THREE = Math.sqrt(3);
    const canvas = document.createElement('canvas');
    document.body.appendChild(canvas);
    const ctx = canvas.getContext('2d');
    canvas.style.display = 'none';
    canvas.width = base * SQRT_THREE;
    canvas.height = base;
    ctx.font = font;
    ctx.textAlign = 'center';
    ctx.translate((base * SQRT_THREE) / 2, base / 2);
    ctx.rotate(rotatAngle * (Math.PI / 180));
    ctx.textBaseline = 'middle';
    ctx.fillStyle = textColor;
    ctx.fillText(watermarkText, 0, 0);
    return (watermarkCache[stringifyOpts] = canvas.toDataURL());
};
export default genWatermark;
